import { useTransportQuery } from "@/transport"

import type { TransportOperationRequest } from "@/types_api/backend/transport/operations"

type TraceFilterSuggestionsRequest =
  TransportOperationRequest<"getTraceFilterSuggestions">
type CustomTraceMetricPreviewRequest =
  TransportOperationRequest<"previewCustomTraceMetric">

const TRACE_FILTER_SUGGESTIONS_STALE_TIME_MS = 5 * 60 * 1000
const CUSTOM_TRACE_METRIC_PREVIEW_STALE_TIME_MS = 30_000

export function useUploadedConversationMetadataTransport(options?: {
  staleTime?: number
}) {
  return useTransportQuery({
    operation: "getUploadedConversationMetadata",
    options,
  })
}

export function useTraceFilterSuggestionsTransport({
  enabled = true,
  request,
}: {
  enabled?: boolean
  request: TraceFilterSuggestionsRequest
}) {
  return useTransportQuery({
    operation: "getTraceFilterSuggestions",
    request,
    options: {
      enabled,
      staleTime: TRACE_FILTER_SUGGESTIONS_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  })
}

export function useCustomTraceMetricPreviewTransport({
  enabled = true,
  request,
}: {
  enabled?: boolean
  request: CustomTraceMetricPreviewRequest
}) {
  return useTransportQuery({
    operation: "previewCustomTraceMetric",
    request,
    options: {
      enabled,
      staleTime: CUSTOM_TRACE_METRIC_PREVIEW_STALE_TIME_MS,
      refetchOnWindowFocus: false,
      select: (data) => ({
        matchedSpanCount: data.matched_span_count,
        sampleValues: data.sample_values ?? [],
        isNumeric: data.is_numeric,
        isBoolean: data.is_boolean,
        okStatusCount: data.ok_status_count,
        errorStatusCount: data.error_status_count,
        latestTimestamp: data.latest_timestamp ?? null,
      }),
    },
  })
}
